import axios from "axios"
import { DateTime } from 'luxon'

export default {
  computed: {
    channexHotels() {
      return ['camping', 'holiday_park', 'tent', 'guest_house', 'resort', 'hostel', 'hotel', 'inn', 'lodge', 'motel', 'apart_hotel', 'riad', 'ryokan', 'capsule_hotel']
    },
    channexVacationRentals() {
      return ['apartment', 'holiday_home', 'chalet', 'boat', 'farm_stay', 'homestay', 'villa', 'country_house']
    },
    channexPropertyTypes() {
      return ['apart_hotel',
              'apartment',
              'boat',
              'camping',
              'capsule_hotel',
              'chalet',
              'country_house',
              'farm_stay',
              'guest_house',
              'holiday_home',
              'holiday_park',
              'homestay',
              'hostel',
              'hotel',
              'inn',
              'lodge',
              'motel',
              'resort',
              'riad',
              'ryokan',
              'tent',
              'villa']
    },
    newPropertyFields() {
      return [
        {
          title: this._('Type'),
          type: 'select',
          name: 'property_type',
          optgroups: [
            {
              label: this._('Property with multiple rooms') + ', ' + 49 + ' ' + this._('€/mo') + ' (' + this._('vat') + ' 0%)',
              options: this.channexHotels.map(t => { return { value: t, name: this.getChannexPropertyTypeTitle(t), disabled: false } }).sort((a, b) => a.name < b.name ? -1 : 1)
            },
            {
              label: this._('Property with room-based pricing') + ', ' + 5 + ' ' + this._('€/mo') + ' + ' + 2 + ' ' + this._('€/mo') + ' ' + this._('for extra rooms') + ' (' + this._('vat') + ' 0%)',
              options: this.channexVacationRentals.map(t => { return { value: t, name: this.getChannexPropertyTypeTitle(t), disabled: false } }).sort((a, b) => a.name < b.name ? -1 : 1)
            }
          ]
        },
        {
          type: 'info',
          text: this._('Price') + ': ' + 49 + ' ' + this._('€/mo') + ' (' + this._('vat') + ' 0%)',
          condition: 'property_type',
          conditionValue: this.channexHotels
        },
        {
          type: 'info',
          text: this._('Price') + ': ' + 5 + ' ' + this._('€/mo') + ' (' + this._('vat') + ' 0%)',
          condition: 'property_type',
          conditionValue: this.channexVacationRentals
        },
        {
          type: 'info',
          text: this._('The cost will be added to your monthly commission invoice.'),
          hideIcon: true,
          condition: 'property_type',
          conditionValue: [...this.channexVacationRentals, ...this.channexHotels]
        },
        {
          type: 'checkbox',
          name: 'terms',
          title: this._('I agree to the current terms and conditions.') + ' <a href="https://johku.fi/ehdot" target="_blank">' + this._('Open Johku Service Contract in a new window.') + ' </a>',
          conditionValue: this.channexPropertyTypes
        }
      ]
    },
  },
  methods: {
    getRoomTypeFields (property, roomCount, linkToExisting) {
      let headerFields = [
        {
          text: this._('Room type details'),
          type: 'h4',
        }
      ]
      if (this.product) {
        headerFields.push({
          title: this._('Name'),
          type: 'static',
          text: this.product.name
        })
      }
      let otherFields = [
        {
          title: this._('Number of adults'),
          type: 'number',
          name: 'occ_adults',
          defaultValue: 1
        },
        {
          title: this._('Number of children'),
          type: 'number',
          name: 'occ_children',
          defaultValue: 0
        },
        {
          title: this._('Number of infants'),
          type: 'number',
          name: 'occ_infants',
          defaultValue: 0
        },
        {
          title: this._('Default occupancy'),
          type: 'number',
          name: 'default_occupancy',
          defaultValue: 1
        }
      ]
      let roomFields = [
        {
          title: this._('Number of rooms'),
          type: 'number',
          name: 'count_of_rooms',
          defaultValue: 1
        }
      ]
      let linkStr = ''
      if (linkToExisting) {
        linkStr = this._('You are linking a new product to an existing property.') + ' ' + this._('This will create a new room type with rooms into the channel manager.')
      }
      if (property && property.property_category !== 'hotel' && roomCount >= 1) {
        roomFields.push({
          type: 'info',
          text: linkStr + ' ' + 
                this._('The base price %s €/month includes one room type and room.').replace('%s', 5) + ' ' + 
                this._('Each additional room or room in a different room type costs %s €/month.').replace('%s', 2) + ' ' + 
                this._('Value added tax will be added to the prices.')
        })
      }
      return [
        ...headerFields,
        ...roomFields,
        ...otherFields
      ]
    },
    async enableMessaging (propertyId) {
      if (!this.isFeatureEnabled('channexmessaging')) {
        return
      }
      let response
      let applicationId = null
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/channexapplications.json?apikey=' + this.apiKey)
        if (response && response.data) {
          const messaging = response.data.find(a => a.code === 'channex_messages')
          if (messaging) {
            applicationId = messaging.id
          }
        }
      } catch(e) {
        this.showError(e)
        return
      }
      try {
        let data = null
        if (propertyId) {
          data = {
            property_id: propertyId,
            application_id: applicationId
          }
        }
        response = await axios.post(this.baseDomain + this.shopId + '/channexapplications.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      if (propertyId) {
        this.loadChannexApplications(propertyId)
      }
    },
    async disableMessaging (propertyId, installationId) {
      if (!this.isFeatureEnabled('channexmessaging')) {
        return
      }
      let response
      try {
        response = await axios.delete(this.baseDomain + this.shopId + '/channexapplications/' + installationId + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.loadChannexApplications(propertyId)
    },
    isMessagingEnabled (propertyId) {
      return this.installedChannexApplications.find(a => a.property_id === propertyId && a.code === 'channex_messages')
    },
    formatOrigin (o) {
      let origin = o
      if (origin === 'gyg') {
        return 'GetYourGuide'
      }
      origin = origin.replace(/channel/, '')
      if (origin.match(/^channex-/)) {
        let parts = origin.split('-')
        switch (parts[1]) {
          case 'boo':
            return 'Booking.com'
          case 'air':
            return 'Airbnb'
          case 'exp':
            return 'Expedia'
          case 'hos':
            return 'Hostelworld'
          case 'goo':
            return 'Google Hotel Ads'
          case 'ago':
            return 'Agoda'
          case 'hot':
            return 'Hotels'
          case 'des':
            return 'Despegar'
          case 'tri':
            return 'Trip.com'
          case 'ctr':
            return 'Ctrip'
          case 'tra':
            return 'Traveloka'
          case 'vrb':
            return 'Vrbo'
          case 'orb':
            return 'Orbitz'
          case 'tik':
            return 'Tiketcom'
        }
        return parts[1]
      }
      return origin
    },
    loadChannexProperties () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/channexproperties.json?apikey=' + this.apiKey)
        } catch(e) {
          this.showError(this._('Error loading properties!'))
          reject()
          return
        }
        this.channexProperties = response.data
        resolve(response.data)
      })
    },
    loadChannexRoomTypes (propertyId) {
      return new Promise(async (resolve, reject) => {
        this.selectedChannexProperty = propertyId
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + (propertyId ? '/channexproperties/' + propertyId  : '') + '/channexroomtypes.json?apikey=' + this.apiKey)
        } catch(e) {
          this.showError(this._('Error loading room types!'))
          reject()
          return
        }
        this.channexRoomTypes = response.data
        resolve(response.data)
      })
    },
    loadChannexApplications (propertyId) {
      return new Promise(async (resolve, reject) => {
        let response
        let propertyStr = ''
        if (propertyId) {
          propertyStr = '/' + propertyId
        }
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/channexapplications' + propertyStr + '.json?installed=true&apikey=' + this.apiKey)
        } catch(e) {
          reject()
          return
        }
        this.installedChannexApplications = response.data
        resolve(response.data)
      })
    },
    getChannexPropertyTitle (propertyId) {
      const property = this.channexProperties.find(p => p.id === propertyId)
      return property ? property.title : ''
    },
    async linkChannexRoomTypeDialog (roomType) {
      if (!this.allProducts || !this.allProducts.length) {
        await this.loadProducts()
      }
      if (!this.allProductTypes || !this.allProductTypes.length) {
        await this.loadProductTypes()
      }
      this.showDialog({
        title: roomType.title,
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Link'),
            class: 'success',
            icon: 'save',
            requiredFields: ['product'],
            handler: (data) => {
              this.linkChannexRoomType(roomType, data.product.value)
            }
          }
        ],
        fields: [
          {
            title: this._('Product'),
            type: 'selectize',
            name: 'product',
            options: this.allProducts.map(p => { return { value: p.id, name: p.name, desc: this.productType(p) }}),
            defaultValue: null
          }
        ]
      })
    },
    async unlinkChannexRoomTypeDialog (roomType) {
      this.showDialog({
        title: this._('Are you sure?'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Unlink'),
            class: 'warning',
            icon: 'link-slash',
            handler: () => {
              this.linkChannexRoomType(roomType, null)
            }
          }
        ]
      })
    },
    async linkChannexRoomType (roomType, productId) {
      const d = {
        id: roomType.id,
        product: productId
      }
      try {
        await axios.patch(this.baseDomain + this.shopId + '/channexroomtypes/' + roomType.id + '.json?apikey=' + this.apiKey, d)
      } catch(e) {
        this.showError(e)
        return
      }
      this.loadChannexRoomTypes()
    },
    async linkChannexPropertyDialog () {
      if (!this.channexProperties || !this.channexProperties.length) {
        await this.loadChannexProperties()
      }
      if (this.channexProperties && this.channexProperties.length) {
        this.showDialog({
          title: this._('building|Link Property'),
          width: 800,
          buttons: [
            {
              title: this._('Close'),
              icon: 'close',
              handler: () => {}
            },
            {
              title: this._('Create new...'),
              class: 'success',
              icon: 'plus',
              handler: () => {
                setTimeout(() => {
                  this.createChannexPropertyAndRoomTypeDialog()
                }, 1)
              }
            },
            {
              title: this._('Ok'),
              class: 'success',
              icon: 'check',
              requiredFields: ['property'],
              handler: (data) => {
                setTimeout(() => {
                  this.linkChannexPropertyAndCreateRoomTypeDialog(data)
                }, 1)
              }
            }
          ],
          fields: [{
            title: this._('building|Property'),
            type: 'selectize',
            name: 'property',
            options: this.channexProperties.map(p => { return { value: p.id, name: p.title }}),
            defaultValue: null
          }]
        })
      } else {
        this.createChannexPropertyAndRoomTypeDialog()
      }
    },
    createChannexPropertyAndRoomTypeDialog () {
      const fields = [
        {
          title: this._('Name'),
          type: 'text',
          name: 'title',
          defaultValue: ''
        },
        {
          type: 'info',
          hideIcon: true,
          text: this._('You can optionally set a cut-off time for making reservations to the property.') + ' ' + this._('You can also specify how many days in advance the reservations must be made.') + ' ' + this._('This setting overrides the setting in product editor for external sales channels.')
        },
        {
          title: this._('Reservation cut-off time'),
          type: 'time',
          name: 'cut_off_time',
          defaultValue: null
        },
        {
          title: this._('Reservation cut-off (days)'),
          type: 'number',
          name: 'cut_off_days',
          defaultValue: null
        }
      ]
      const separator = [
        {
          type: 'separator',

        }
      ]
      if (this.isFeatureEnabled('channexmessaging')) {
        fields.push({
          title: this._('Messaging'),
          type: 'checkbox', 
          name: 'messaging',
          defaultValue: 0
        })
      }
      this.showDialog({
        title: this._('building|Add Property'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('verb|Order'),
            class: 'success',
            icon: 'check',
            requiredFields: ['title', 'property_type', 'terms', 'count_of_rooms', 'occ_adults', 'default_occupancy'],
            handler: async (data) => {
              let propertyId
              try {
                propertyId = await this.createChannexProperty(data)
              } catch(e) {
                return this.showError(e)
              }
              await this.createChannexRoomType(propertyId, this.product.id, data)
              if (parseInt(data.messaging)) {
                this.enableMessaging(propertyId)
              }
            }
          }
        ],
        fields: [
          ...fields,
          ...this.newPropertyFields,
          ...separator,
          ...this.getRoomTypeFields(null, 0)
        ]
      })
    },
    async linkChannexPropertyAndCreateRoomTypeDialog (propertyData) {
      if (!propertyData || !propertyData.property || !propertyData.property.value) {
        return false
      }
      const propertyId = propertyData.property.value
      const property = this.channexProperties.find(p => p.id === propertyId)
      let roomCount = 0
      await this.loadChannexRoomTypes()
      if (this.channexRoomTypes && this.channexRoomTypes.length) {
        const existingRoomTypes = this.channexRoomTypes.filter(rt => rt.property_id === propertyId)
        roomCount = existingRoomTypes.reduce((acc, rt) => acc + rt.count_of_rooms, 0)
        if (property.property_category === 'hotel') {
          const roomTypeCount = existingRoomTypes.length
          if (roomTypeCount >= 20) {
            this.showError(this._('You can only have up to 20 room types for this type of property.'))
            return
          }
        }
      }
      this.showDialog({
        title: this._('Room Type'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['count_of_rooms', 'occ_adults', 'default_occupancy'],
            handler: async (data) => {
              if (this.product) {
                try {
                  await this.createChannexRoomType(propertyId, this.product.id, data)
                } catch(e) {
                  this.showError(e)
                  return
                }
              }
            }
          }
        ],
        fields: this.getRoomTypeFields(property, roomCount, true)
      })
    },
    async modifyChannexPropertyDialog (property) {
      let fields = [
        {
          title: this._('Name'),
          type: 'text',
          name: 'title',
          defaultValue: property ? property.title : ''
        },
        {
          type: 'info',
          hideIcon: true,
          text: this._('You can optionally specify how many days in advance and by which time reservations to the property must be made.') + ' ' + this._('To allow reservations on the same day before a specific time, leave the (days) field empty.'),
        },
        {
          title: this._('Reservation cut-off time'),
          type: 'time',
          name: 'cut_off_time',
          defaultValue: this.cutOffTimeForPicker(property && property.cut_off_time)
        },
        {
          title: this._('Reservation cut-off (days)'),
          type: 'number',
          name: 'cut_off_days',
          defaultValue: property ? property.cut_off_days : null
        }
      ]
      let requiredFields = ['title']
      let applications = []
      let messagingEnabled = false
      if (!property) {
        fields = [...fields, ...this.newPropertyFields]
        requiredFields.push('property_type', 'terms')
      } else {
        applications = await this.loadChannexApplications(property.id)
        messagingEnabled = applications.find(a => a.code === 'channex_messages')
      }
      if (this.isFeatureEnabled('channexmessaging')) {
        fields.push({
          title: this._('Messaging'),
          type: 'checkbox', 
          name: 'messaging',
          defaultValue: messagingEnabled ? 1 : 0
        })
      }
      this.showDialog({
        title: property ? property.title : this._('building|Add Property'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: property ? this._('Save') : this._('verb|Order'),
            class: 'success',
            icon: property ? 'save' : 'check',
            requiredFields,
            handler: async (data) => {
              try {
                let propertyId
                if (property && property.id) {
                  propertyId = property.id
                  await this.modifyChannexProperty(property, data)
                } else {
                  propertyId = await this.createChannexProperty(data)
                }
                if (!messagingEnabled && parseInt(data.messaging)) {
                  this.enableMessaging(propertyId)
                } else if (messagingEnabled && !parseInt(data.messaging)) {
                  this.disableMessaging(propertyId, messagingEnabled.id)
                }
              } catch(e) {
                this.showError(e)
              }
            }
          }
        ],
        fields
      })
    },
    cutOffTimeForPicker (value) {
      if (!value || typeof value !== 'string') {
        return null
      }
      const match = value.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/)
      if (!match) {
        return null
      }
      const hours = Number.parseInt(match[1], 10)
      const minutes = Number.parseInt(match[2], 10)
      if (hours > 23 || minutes > 59) {
        return null
      }
      return { hours, minutes, seconds: 0 }
    },
    cutOffTimeForApi (value) {
      if (!value) {
        return null
      }
      const hours = Number.parseInt(value.hours, 10)
      const minutes = Number.parseInt(value.minutes, 10)
      if (!Number.isFinite(hours) || !Number.isFinite(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
        return null
      }
      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':00'
    },
    createChannexProperty(data) {
      return new Promise(async (resolve, reject) => {
        let response
        data.cut_off_time = this.cutOffTimeForApi(data.cut_off_time)
        try {
          response = await axios.post(this.baseDomain + this.shopId + '/channexproperties.json?apikey=' + this.apiKey, data)
        } catch(e) {
          reject(e)
          return
        }
        this.loadChannexProperties()
        resolve(response.data)
      })
    },
    modifyChannexProperty(property, data) {
      return new Promise(async (resolve, reject) => {
        data.id = property.id
        data.cut_off_time = this.cutOffTimeForApi(data.cut_off_time)
        try {
          await axios.put(this.baseDomain + this.shopId + '/channexproperties/' + property.id + '.json?apikey=' + this.apiKey, data)
        } catch(e) {
          reject(e)
          return
        }
        this.loadChannexProperties()
        resolve()
      })
    },
    removeChannexPropertyDialog (property) {
      this.showDialog({
        title: this._('Are you sure? The selected property will be deleted permanently.'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Delete'),
            class: 'danger',
            icon: 'trash',
            handler: () => {
              this.removeChannexProperty(property)
            }
          }
        ]
      })
    },
    async removeChannexProperty (property) {
      const data = { id: property.id }
      try {
        await axios.delete(this.baseDomain + this.shopId + '/channexproperties/' + property.id + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        return this.showError(e)
      }
      this.loadChannexProperties()
      this.loadChannexRoomTypes()
    },
    async createChannexRoomTypeForProperty (property) {
      let roomCount = 0
      if (this.channexRoomTypes && this.channexRoomTypes.length) {
        const existingRoomTypes = this.channexRoomTypes.filter(rt => rt.property_id === property.id)
        roomCount = existingRoomTypes.reduce((acc, rt) => acc + rt.count_of_rooms, 0)
        if (property.property_category === 'hotel') {
          const roomTypeCount = existingRoomTypes.length
          if (roomTypeCount >= 20) {
            this.showError(this._('You can only have up to 20 room types for this type of property.'))
            return
          }
        }
      }
      this.createChannexRoomTypeDialog(property, roomCount)
    },
    async createChannexRoomTypeDialog (property, roomCount) {
      if (!this.allProducts || !this.allProducts.length) {
        await this.loadProducts()
      }
      if (!this.allProductTypes || !this.allProductTypes.length) {
        await this.loadProductTypes()
      }
      this.showDialog({
        title: this._('Add Room Type'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Save'),
            class: 'success',
            icon: 'save',
            requiredFields: ['product', 'count_of_rooms', 'occ_adults', 'default_occupancy'],
            handler: (data) => {
              this.createChannexRoomType(property.id, data.product.value, data)
            }
          }
        ],
        fields: [
          {
            title: this._('Product'),
            type: 'selectize',
            name: 'product',
            options: this.allProducts.map(p => { return { value: p.id, name: p.name, desc: this.productType(p) }}),
            defaultValue: null
          },
          ...(this.getRoomTypeFields(property, roomCount))
        ]
      })
    },
    createChannexRoomType (propertyId, productId, data) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          const postData = {
            property_id: propertyId,
            product: productId,
            count_of_rooms: data.count_of_rooms,
            occ_adults: data.occ_adults,
            occ_children: data.occ_children,
            occ_infants: data.occ_infants,
            default_occupancy: data.default_occupancy
          }
          response = await axios.post(this.baseDomain + this.shopId + '/channexroomtypes.json?apikey=' + this.apiKey, postData)
        } catch(e) {
          this.showError(e)
          reject(e)
          return
        }
        this.loadChannexRoomTypes()
        resolve(response.data)
      })
    },
    async modifyChannexRoomTypeDialog (property, roomType, callback) {
      this.showDialog({
        title: roomType.title,
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Save'),
            class: 'success',
            icon: 'save',
            requiredFields: ['count_of_rooms', 'occ_adults', 'occ_children', 'occ_infants', 'default_occupancy'],
            handler: (data) => {
              this.modifyChannexRoomType(roomType, data, callback)
            }
          }
        ],
        fields: [
          {
            title: this._('Number of rooms'),
            type: 'number',
            name: 'count_of_rooms',
            defaultValue: roomType.count_of_rooms
          },
          {
            title: this._('Number of adults'),
            type: 'number',
            name: 'occ_adults',
            defaultValue: roomType.occ_adults
          },
          {
            title: this._('Number of children'),
            type: 'number',
            name: 'occ_children',
            defaultValue: roomType.occ_children
          },
          {
            title: this._('Number of infants'),
            type: 'number',
            name: 'occ_infants',
            defaultValue: roomType.occ_infants
          },
          {
            title: this._('Default occupancy'),
            type: 'number',
            name: 'default_occupancy',
            defaultValue: roomType.default_occupancy
          }
        ]
      })
    },
    async modifyChannexRoomType (roomType, data, callback) {
      try {
        const postData = {
          id: roomType.id,
          property_id: roomType.property_id,
          title: roomType.title,
          count_of_rooms: data.count_of_rooms,
          occ_adults: data.occ_adults,
          occ_children: data.occ_children,
          occ_infants: data.occ_infants,
          default_occupancy: data.default_occupancy
        }
        await axios.put(this.baseDomain + this.shopId + '/channexroomtypes/' + roomType.id + '.json?apikey=' + this.apiKey, postData)
      } catch(e) {
        this.showError(e)
        return
      }
      if (callback) {
        callback()
      } else {
        this.loadChannexRoomTypes()
      }
    },
    removeChannexRoomTypeDialog (roomType) {
      this.showDialog({
        title: this._('Are you sure? The selected room type will be deleted permanently.'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Delete'),
            class: 'danger',
            icon: 'trash',
            handler: () => {
              this.removeChannexRoomType(roomType)
            }
          }
        ]
      })
    },
    async removeChannexRoomType (roomType) {
      try {
        await axios.delete(this.baseDomain + this.shopId + '/channexroomtypes/' + roomType.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.loadChannexRoomTypes()
    },
    getChannexNumberOfRooms (property) {
      if (!this.channexRoomTypes || !this.channexRoomTypes.length) {
        return 0
      }
      return this.channexRoomTypes
        .filter(rt => rt.property_id === property.id)
        .reduce((sum, rt) => sum + (rt.count_of_rooms || 0), 0)
    },
    getChannexPropertyCategoryTitle (category) {
      switch (category) {
        case 'hotel':
          return this._('Hotel')
        case 'vacation_rental':
        case 'vacationrental':
          return this._('Vacation rental')
        default:
          return category
      }
    },
    getChannexPropertyTypeTitle (type) {
      switch (type) {
        case 'apart_hotel':
          return this._('Aparthotel')
        case 'apartment':
          return this._('Apartment')
        case 'boat':
          return this._('Boat')
        case 'camping':
          return this._('Camping site')
        case 'capsule_hotel':
          return this._('Capsule hotel')
        case 'chalet':
          return this._('Chalet')
        case 'country_house':
          return this._('Country house')
        case 'farm_stay':
          return this._('Farm stay')
        case 'guest_house':
          return this._('Guest house')
        case 'holiday_home':
          return this._('Holiday home')
        case 'holiday_park':
          return this._('Holiday park')
        case 'homestay':
          return this._('Homestay')
        case 'hostel':
          return this._('Hostel')
        case 'hotel':
          return this._('Hotel')
        case 'inn':
          return this._('Inn')
        case 'lodge':
          return this._('Lodge')
        case 'motel':
          return this._('Motel')
        case 'resort':
          return this._('Resort')
        case 'riad':
          return this._('Riad')
        case 'ryokan':
          return this._('Ryokan')
        case 'tent':
          return this._('Tented camp')
        case 'villa':
          return this._('Villa')
        default:
          return type
      }
    }
  }
}